import React, { useState, useEffect } from 'react';
import { Copy, Check } from 'lucide-react';
import './SessionToken.css';

interface SessionTokenProps {
  className?: string;
}

const SessionToken: React.FC<SessionTokenProps> = ({ className = '' }) => {
  const [token, setToken] = useState<string>('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    // Get token from localStorage (same as the main app uses)
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  const handleCopyToken = async () => {
    if (!token) return;
    
    try {
      await navigator.clipboard.writeText(token);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy token:', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = token;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className={`session-token-container ${className}`}>
      <div className="session-token-content">
        <label htmlFor="session-token" className="session-token-label">
          Session Token:
        </label>
        <div className="session-token-input-group">
          <input
            id="session-token"
            type="text"
            value={token}
            readOnly
            className="session-token-input"
            placeholder="No token available"
          />
          <button
            type="button"
            onClick={handleCopyToken}
            className={`session-token-copy-btn ${copied ? 'copied' : ''}`}
            disabled={!token}
            title={copied ? 'Copied!' : 'Copy token to clipboard'}
          >
            {copied ? <Check size={16} /> : <Copy size={16} />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionToken;
